/** Competition expected result kinds (A dimension). */
export const EXPECTED_RESULT_KINDS = [
  { id: "classement_step", labelKey: "smartExpectedKindClassement" },
  { id: "ranking_points", labelKey: "smartExpectedKindPoints" },
  { id: "match_target", labelKey: "smartExpectedKindMatch" },
  { id: "category", labelKey: "smartExpectedKindCategory" },
  { id: "custom", labelKey: "smartExpectedKindCustom" },
];

export function buildExpectedResultLabel({ kind, target = {}, t }) {
  const value = target?.value != null ? String(target.value).trim() : "";
  if (target?.label) return String(target.label).trim();
  switch (kind) {
    case "classement_step":
      return value
        ? t("smartExpectedLabelClassement", { value, defaultValue: `Reach ranking step ${value}` })
        : t("smartExpectedLabelClassementGeneric", { defaultValue: "Ranking progression" });
    case "ranking_points":
      return value
        ? t("smartExpectedLabelPoints", { value, defaultValue: `${value} ranking points` })
        : t("smartExpectedLabelPointsGeneric", { defaultValue: "Points target" });
    case "match_target":
      return value || t("smartExpectedLabelMatch", { defaultValue: "Win in competition" });
    case "category":
      return value
        ? t("smartExpectedLabelCategory", { value, defaultValue: `Top ${value} in category` })
        : t("smartExpectedLabelCategoryGeneric", { defaultValue: "Category placement" });
    default:
      return value || t("smartExpectedResult", { defaultValue: "Expected result" });
  }
}

export function competitionExpectedOptions(t) {
  return EXPECTED_RESULT_KINDS.map((k) => ({
    id: k.id,
    kind: k.id,
    label: t(k.labelKey, { defaultValue: k.id }),
    horizon: "mid",
  }));
}
